import { render, staticRenderFns } from "./newworker.vue?vue&type=template&id=4edf5870&"
import script from "./newworker.vue?vue&type=script&lang=js&"
export * from "./newworker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports